import styled from 'styled-components'

import { helpers } from '../../../styles/theme'

export const LoadingLabel = styled.span`
	margin-left: -3px;
	color: ${helpers.color.input.contentLoading};
	align-self: center;
`
